import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

const object = vnObject
const { __ } = wp.i18n

$(document).ready(() => {
  const landingJpoForm = $('.js-jpo-form')


  if (landingJpoForm.length) {
    const centerSelect = landingJpoForm.find('#training_center_id')
    const dateSelect = landingJpoForm.find('#training_date_id')
    const trainingBranchSelect = landingJpoForm.find('.js-training-branches')
    const trainingBranches = Object.keys(object.training_branches).map((k) => object.training_branches[k])

    var selectize
    trainingBranchSelect.selectize({
      preload: true,
      valueField: 'id',
      labelField: 'name',
      searchField: 'name',
      plugins: ['remove_button'],
      delimiter: ',',
      options: trainingBranches,
      closeAfterSelect: true,
      onInitialize: function() {
        selectize = this
        var selected_items = []
        selectize.setValue(selected_items)
      },
    })

    centerSelect.on('change', center => {

      let options = `<option value="" selected disabled>${__('Choose a JPO date', 'vn')}</option>`
      const datas = object.training_centers_dates[center.target.value]
      if (datas) {
        for (const key in datas) {
          const data = datas[key]
          options += `<option value="${data.id}">${data.name}</option>`
        }
      }

      selectize.clearOptions()
      selectize.addOption(trainingBranches.filter((e) => e.centers.includes(center.target.value)))
      dateSelect.html(options)
    })

    landingJpoForm.parsley().on('form:success', function() {
      landingJpoForm.attr('data-success', 'true')
    })

    landingJpoForm.parsley().on('form:error', function() {
      landingJpoForm.attr('data-success', 'false')
    })

    landingJpoForm.on('submit', function(e) {
      e.preventDefault()
      e.stopPropagation()

      const $form = $(this)
      const formData = new FormData($form[0])

      formData.append('action', 'vn_register_jpo_form')

      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: () => {
          $form.addClass('sending')
          Alert('warning', object.formWait, false)
        },
        success: (res) => {
          $form.removeClass('sending')
          Alert(res.data.success, res.data.message)
          if (res.data.success) {
            window.location = res.data.redirect
          }
        },
        error: (res) => {
          $form.removeClass('sending')

          if (res.data.success) {
            window.location = res.data.redirect
          }

          Alert(res.data.error, res.data.message)
        },
      })
    })
  }
})
